<template>
  <div class="OAMenu">
    <div class="OAMenu-header">
      <span class="title">{{title}}</span>
      <i class="iconfont icon-caidan" @click="toggle" ref="iconMenu"></i>
    </div>
    <el-menu :default-active="active" router :collapse="isCollapse" :unique-opened="true">
      <my-nav :menuList="menus"></my-nav>
    </el-menu>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import store from "@/store";
import myNav from "./components/myNav";
import { title } from "@/common/util.js";

export default {
  name: "OAMenu",
  data() {
    return {
      title: "OA人事管理系统",
      active: ""
    };
  },
  components: { myNav },
  computed: {
    ...mapGetters(["menus", "routers"]),
    isCollapse() {
      return store.getters.isCollapse;
    }
  },
  methods: {
    toggle() {
      this.$store.commit("changeCollapse");
      if (this.isCollapse) {
        this.$refs.iconMenu.className = "iconfont icon-caidan active";
        this.title = "";
      } else {
        this.$refs.iconMenu.className = "iconfont icon-caidan";
        this.title = "OA人事管理系统";
      }
    }
  },
  mounted() {},
  created() {
    this.active = this.$route.name;
    title(this.$route.meta.title);
  }
};
</script>




// WEBPACK FOOTER //
// src/components/OAMenu/OAMenu.vue